/**
 *  @author => @RMT_FRONT_CORE/CLI
 * */
import React from 'react';
import {Redirect} from 'react-router-dom';

import settings from 'config/constants';

const GRMTAlertSettingsReport = React.lazy(() => import('./views/pages/AlertSettingsReport'));

const subUrl = settings.PRODUCTS.GRMT.path;
const modulePath = `${subUrl}/reports`;

type Route = {
    path: string,
    name: string,
    exact: boolean,
    page: Function,
    subRoutes?: Array<Route>,
}

const ROUTES: Array<Route> = [
    { path: `/${modulePath}/`, name: 'Reports', exact: true, page: () => <Redirect to={`/${modulePath}/alert-settings-report`} /> },
    { path: `/${modulePath}/alert-settings-report`, name: 'Alert Monitor', exact: true, page: GRMTAlertSettingsReport }
];

export default ROUTES;
